import { Injectable } from '@angular/core'
import { CollectionRepository, FirestoreQueryBuilder } from '@engineering11/web-api-firebase'
import { COLLECTIONS, ICandidateJobVM } from 'shared-lib'
@Injectable({ providedIn: 'root' })
export class CandidateJobVMRepository extends CollectionRepository<ICandidateJobVM> {
  protected COLLECTION = COLLECTIONS.CANDIDATE_JOB_VM

  get(key: string) {
    return super.get(key)
  }

  getAll() {
    return super.getAll()
  }

  getAllForUserValueChanges(userId: string) {
    const query = new FirestoreQueryBuilder().where('userId', '==', userId).build()
    return super._queryValueChanges(this.COLLECTION, query)
  }

  getAllForUser(userId: string) {
    const query = new FirestoreQueryBuilder().where('userId', '==', userId).build()
    return super._query(this.COLLECTION, query)
  }
}
